import { USERS } from "../Constants/Endpoinst";
import { ApiRequestInterceptor } from "./apiRequest";

export const fetchLogin = async (body) => {
  const method = "POST";
  const response = await ApiRequestInterceptor(USERS.login, method, body);

  if (response.code === 200 && response.data.token) {
    localStorage.setItem("logindata", JSON.stringify(response));
    window.dispatchEvent(new Event("authChange"));
  } else {
    const errorMessage = response?.data?.error || 'Error desconocido';
    throw new Error(errorMessage);
  }
};